// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import accessFactory from '@/access';

export type AccessInstance = ReturnType<typeof accessFactory>;
